module.exports = __webpack_public_path__ + "static/media/A&U21.315d7476.png";